import { CONFIG } from '../core/config';
import { ModelStatus } from './model-status';
import { VersionedEntity } from './versioned-entity';
import { ViewModel } from './view-model';


export interface NodeInterface extends VersionedEntity {
  nodeId: string;
  nodeName: string;
  nodeLabel: string;
  status: ModelStatus;
  canEdit: boolean;
}

export class Node implements ViewModel, NodeInterface {
  readonly friendlyTypeNameSingular = 'Node';
  readonly apiRoute: string = CONFIG.apiRoutes.node;
  nodeId: string;
  nodeName: string;
  nodeLabel: string;
  status: ModelStatus;
  version: number;
  clonedFrom: string;
  canEdit: boolean;

  get name() { return this.nodeName; }
  set name(value: string) { this.nodeName = value; }

  constructor() {
    this.nodeName = '';
    this.version = 0;
  }

  json() {
    return this;
  }

  loadFromJson(data) {
    this.nodeId = data.nodeId;
    this.nodeName = data.nodeName;
    this.nodeLabel = data.nodeLabel;
    this.status = data.status;
    this.version = data.version;
    this.clonedFrom = data.clonedFrom;
    this.canEdit = data.canEdit;
  }
}
